import { Rating } from '@/features/types';
import type { MantineTheme } from '@mantine/core';

export const ratingToString = {
  [Rating.Unknown]: 'unknown',
  [Rating.None]: 'none',
  [Rating.Minor]: 'minor',
  [Rating.Low]: 'low',
  [Rating.Medium]: 'medium',
  [Rating.High]: 'high',
} as const;

type AllowedRatingStrings = (typeof ratingToString)[Rating];

export function getRatingId(
  rating: Rating
): `level3.${AllowedRatingStrings}RatingLabel` {
  const key = ratingToString[rating];
  return `level3.${key}RatingLabel`;
}

export function getRatingLabel(rating: Rating): AllowedRatingStrings {
  return ratingToString[rating];
}

export function getRatingColor(rating: Rating, theme: MantineTheme): string {
  const ratingKey = ratingToString[rating];
  return theme.other.riskColor[ratingKey];
}
